import React, {Component} from 'react';

export class MultiSelectSectionItem extends Component {

    render() {
        return (
            <li key={this.props.sectionName}>
                <label className={`multi-select-section`}>
                    <div className="multi-select-item-name">{this.props.sectionName}</div>
                </label>
            </li>
        )
    }
}
